import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useDispatch } from 'react-redux';
import { useRouter } from '../../../../@casino/useRouter';
import {useFormik, FormikContext} from "formik";
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { setPostCreateCurrency } from '../store/thunk/setPostCreateCurrency';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%', 
    },
    mt0: {
        marginTop: 0
    },
    wrapActiveBonus: {
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '70%'
    },
}))

const CodeCountryCreate = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const classes = useStyles();

    const onSubmit = (store) => {
        dispatch(setPostCreateCurrency(store))
    }

    const initialValues = {
        currency: '',
        symbol: ''
    }

    const formik = useFormik({onSubmit, initialValues});

    return (
        <div style={{padding: '0 20px'}}>
            <Title 
                label="Добавление кода страны" 
                labelBtn="Назад"
                button={() => router.history.push('/settings/messanger')}
            />
            <div style={{
                padding: 20,
                background: '#1b2039', 
                borderRadius: 8, 
            }}>
                <FormikContext.Provider value={formik}>
                    <form onSubmit={formik.handleSubmit}>
                    <label htmlFor="currency" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>Валюта</span>
                            <input 
                                type="text" 
                                name="currency" 
                                id="currency" 
                                className={classes.text}
                                value={formik.values.currency} 
                                onChange={(v) => formik.setFieldValue('currency', v.target.value)}
                            />
                        </label>
                        <label htmlFor="symbol" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>Символ</span>
                            <input 
                                type="text" 
                                name="symbol" 
                                id="symbol" 
                                className={classes.text}
                                value={formik.values.symbol} 
                                onChange={(v) => formik.setFieldValue('symbol', v.target.value)}
                            />
                        </label>
                        
                        <div>
                            <span 
                                onClick={() => formik.submitForm()}
                                style={{
                                    color: '#141b33',
                                    cursor: 'pointer',
                                    padding: '10px',
                                    background: '#ffc324',
                                    borderRadius: '4px',
                                }}
                            >
                                Добавить
                            </span>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
        </div>
    )
}

export default CodeCountryCreate;